import { TILE_CARD_VIEW_TYPES } from 'src/consumer/constants'
import { getCorrectUsableItemType } from './tile-carousels-utils'

class TileInfo {
  constructor(props) {
    this.tileData = props?.tileData
    this.currentItemType = getCorrectUsableItemType(props?.tileData?.itemType)
    this.currentCategoryType = props?.tileData?.categoryType
  }
  setTileData = (tileData) => {
    this.tileData = tileData
  }

  setTileItemType(itemType) {
    this.currentItemType = itemType
  }

  setCurrentCategoryType(categoryType) {
    this.currentCategoryType = categoryType
  }
}

export class SquareMid extends TileInfo {
  constructor(props) {
    super(props)
    this.getTitleField = (item) => item?.title
    this.getMainImage = (item) => item?.coverIcon
    this.getSecondaryCardImage = (item) => item?.coverIcon
    this.getSecondaryText = (item) => 'Activity Plan'
    this.getActionButtonLogic = (item) => ({
      text: 'Start',
      onClick: () => {},
    })
    this.onClick = null
  }

  setActionButtonLogicFunction(functionToSet) {
    this.getActionButtonLogic = functionToSet
  }

  setSecondaryTextFunction(functionToSet) {
    this.getSecondaryText = functionToSet
  }

  setTitleField(functionToSet) {
    this.getTitleField = functionToSet
  }

  setMainImage(functionToSet) {
    this.getMainImage = functionToSet
  }

  setSecondaryCardImage(functionToSet) {
    this.getSecondaryCardImage = functionToSet
  }

  setActionButtonLogic(functionToSet) {
    this.getActionButtonLogic = functionToSet
  }

  setOnClick(functionToSet) {
    this.onClick = functionToSet
  }
}

export class ArticleLayout extends SquareMid {
  constructor(props) {
    super(props)
    this.getPersonDetails = null
  }
  setPersonDetails(functionToSet) {
    this.getPersonDetails = functionToSet
  }
}

export class SpreadBoard extends SquareMid {
  constructor(props) {
    super(props)
    this.getSecondaryItems = (item) => []
    this.getSecondaryItemTitle = (item) => item?.plannedActivity?.activityTitle
    this.getSecondaryItemSecondaryText = (item) => item?.plannedActivity?.customCategoryTitle
    this.getSecondaryItemImage = (item) => item?.coverIcon
    this.getSecondaryItemViewType = (item) => TILE_CARD_VIEW_TYPES.default
    this.getPreselected = (index) => index === 0
    this.secondaryItemOnClick = null
    this.getBoxedMainTitleText = null
    this.getBoxedMainTitleSubText = null
    this.getTertiaryTitle = null
  }
  setSecondaryItemsFunction(functionToSet) {
    this.getSecondaryItems = functionToSet
  }
  setSecondaryItemImage(functionToSet) {
    this.getSecondaryItemImage = functionToSet
  }
  setSecondaryItemTitle(functionToSet) {
    this.getSecondaryItemTitle = functionToSet
  }
  setSecondaryItemSecondaryText(functionToSet) {
    this.getSecondaryItemSecondaryText = functionToSet
  }
  setSecondaryItemViewType(functionToChange) {
    this.getSecondaryItemViewType = functionToChange
  }
  setPreselected(functionToSet) {
    this.getPreselected = functionToSet
  }
  setSecondaryItemOnClick(functionToSet) {
    this.secondaryItemOnClick = functionToSet
  }
  setBoxedMainTitleText(functionToSet) {
    this.getBoxedMainTitleText = functionToSet
  }
  setBoxedMainTitleSubText(functionToSet) {
    this.getBoxedMainTitleSubText = functionToSet
  }
  setTertiaryTitle(functionToSet) {
    this.getTertiaryTitle = functionToSet
  }
}

export class MentorCardPortrait extends SquareMid {
  constructor(props) {
    super(props)
    this.getTertiaryText = (item) => ''
    this.getPrimarySpecialText = null
    this.getSecondarySpecialText = null
    this.getTertiarySpecialText = null
    this.getSecondaryActionButtonLogic = (item) => ({
      text: '',
      onClick: () => {},
    })
  }
  setTertiaryText(functionToSet) {
    this.getTertiaryText = functionToSet
  }
  setPrimarySpecialText(functionToSet) {
    this.getPrimarySpecialText = functionToSet
  }
  setSecondarySpecialText(functionToSet) {
    this.getSecondarySpecialText = functionToSet
  }
  setTertiarySpecialText(functionToSet) {
    this.getTertiarySpecialText = functionToSet
  }
  setSecondaryActionButtonLogic(functionToSet) {
    this.getSecondaryActionButtonLogic = functionToSet
  }
}

// const CombinedClass = new MultipleInheritance([ArticleLayout, SpreadBoard])

export class DefaultTileHeadingLogic extends TileInfo {
  constructor(props) {
    super(props)
    this.getTitle = (item) => item?.title
    // title: 'itemType?.title',
    this.getAltText = (item) => item?.altText
    // altText: 'Test Alt Text',
    this.showAll = false
    this.onClick = null
    this.tileItemType = null
  }

  setGetTitle = (func) => {
    this.getTitle = func
  }
  setGetAltText = (func) => {
    this.getAltText = func
  }
  setShowAll = (func) => {
    this.getShowAll = func
  }
  setOnClick = (func) => {
    this.getOnClick = func
  }
}
